export { SmallParagraph } from './smallParagraph';